'use strict';

angular.module('autoProduct', []);



// WEBPACK FOOTER //
// ./src/app/service/auto-product/auto-product.module.js